export default __webpack_public_path__ + "static/media/dive_shot10.7159d6e5.png";